import $http from '$http';
import {
  cloneDeep,
  util,
  isCorrectVal,
  isDate,
  lg
} from 'utils';
import validate from 'validate';
export default {
  methods: {
    //获取列表
    getList() {
      let params = {
        Sid: this.$store.state.sysSid,
        Session: this.$store.state.sysSession,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };

      //过滤没有查询的值传入服务器
      for (var i in this.query) {
        if (this.query.hasOwnProperty(i)) {
          if (isCorrectVal(this.query[i])) {
            // 去除空格trimAllSpace(str, is_global)  true 为去除所有空格
            if (typeof this.query[i] == 'string') {
              this.query[i] = util.trimAllSpace(this.query[i]);
            }
            params[i] = this.query[i]
          }
        };
      }
      this.loading = true;
      this.TotalClassNum = 0
      this.TotalOpenClassNum = 0
      this.TotalBuyNum = 0
      $http.get("api/MeetOrder/GetMeetResourceByPage", params).then(res => {
        let {
          Data,
          Cnt,
          MoreData
        } = res.data;
        this.loading = false;
        util.doResult(this, res, () => {
          this.lists = Data;
          this.TotalClassNum = MoreData.TotalClassNum;
          this.TotalOpenClassNum = MoreData.TotalOpenClassNum;
          this.TotalBuyNum = MoreData.TotalMoreNum;
          this.totalSize = Cnt;
        });
      });
    },
  }
}


// WEBPACK FOOTER //
// ./src/pages/Order/MeetOrederDetails/services.js